/**
 * TV 2 Auth utilities
 * @type {string}
 */

export const AUTH_STORAGE_KEY = "tv2_auth_jwt";


export default {

    /**
     * Get JWT token
     * @returns {string}
     */
    getToken() {
        return localStorage.getItem(AUTH_STORAGE_KEY);
    },

    /**
     * Set JWT token
     * @param jwt
     */
    setToken(jwt) {
        localStorage.setItem(AUTH_STORAGE_KEY, jwt);
    },


    /**
     * Delete JWT token
     */
    deleteToken(){
        localStorage.removeItem(AUTH_STORAGE_KEY);
    }
}
